import { Injectable } from '@angular/core';
import { Usecase } from '../../../../domain/usecase/usecase.interface';
import { Result } from '../../../../domain/models/http-response.model';
import { CategoriesRepository } from '../../../../domain/repositories/categories.repository';

@Injectable({ providedIn: 'root' })
export class GetCategoryUsecase
  implements Usecase<string, Promise<Result<unknown, Error>>>
{
  constructor(private categoriesRepository: CategoriesRepository) {}

  async execute(idOrSlug: string) {
    return this.categoriesRepository.getCategory(idOrSlug);
  }
}
